/**
 * Presets a feature schema names (`style: 'percentage'`) so header and cells share alignment,
 * weight and number format. Copied from portal-ui-lib's `cell-styles.util.ts`.
 */
export interface CellStyleDefinition {
  align: 'left' | 'center' | 'right';
  className?: string;
  format?: string;
}

const CELL_STYLES: Record<string, CellStyleDefinition> = {
  text: { align: 'left' },
  'text-left': { align: 'left' },
  'text-right': { align: 'right' },
  number: { align: 'right', format: 'integer' },
  percentage: { align: 'right', className: 'font-semibold', format: 'percent:1' },
  'currency-dkk': { align: 'right', className: 'font-semibold', format: 'currency-dkk:0' },
  center: { align: 'center' },
};

export function resolveCellStyle(name: string | null | undefined): CellStyleDefinition | null {
  return name ? (CELL_STYLES[name] ?? null) : null;
}
